import { KeycloakService } from 'keycloak-angular';
import { KeycloakConfig } from '../interfaces';

export function initializeKeycloak(keycloakService: KeycloakService, keycloakConfig: KeycloakConfig) {
  return () =>
    keycloakService.init({
      config: {
        url: keycloakConfig.url,
        realm: keycloakConfig.realm,
        clientId: keycloakConfig.clientId,
      },
      initOptions: {
        pkceMethod: 'S256',
        onLoad: 'check-sso',
        checkLoginIframe: false,
        silentCheckSsoFallback: false,
        silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
      },
    });
}